import { JewelryCustomDesign } from '@/features/accounts/custom-design/const';
import { HandoverModel } from './../../../models/handover';
import { LastedMessage } from '@/features/livestream/detail/const';
import { ProductDiscount } from '@/features/products/shared';
import {
  MessageModel,
  ConversationModel,
  ProductModel,
  ImageModel,
  AttributeModel,
  ConversationType,
  UserModel,
} from '@/models';

/**
 * Props
 */

export type InfoProductPartialProps = {
  productId: number;
  messageId: number;
};

/**
 * Models
 */

export { ConversationType };

export interface Message extends MessageModel {
  handover?: HandoverModel;
}

export interface UserConversation {
  user_country: string;
  user_id: number;
  user_name: string;
  user_phone: number;
  user_role: string;
  user_avatar: string;
  user_status: string;
  id?: number;
  guest_id?: number;
  conversation_user_id?: number;
};

export type RatingStaffPayload = {
  staff_id: number;
  object_id: number;
  object_name: string;
  object_type: string;
  content: string;
  number_rating: number;
};

export type RatingStaffResponse = {
  id: number;
  object_id: any;
};
export interface Conversation extends ConversationModel {
  user_conversations?: UserConversation[];
  supported_by?: number;
  last_message?: LastedMessage;
  metadata?: {
    custom_jewelry_request: JewelryCustomDesign;
  }
}

export type FetchRatingStaffPayload = {
  staffId: number | string;
  pId: number | string;
};

export type RatingStaffQueryResponse = {
  id: number;
  number_rating: number;
  content: string;
  user_id: number;
  staff_id: number;
  object_id: number;
  object_name: string;
  object_type: string;
  created_at: string;
  updated_at: string;
};
interface Product extends ProductModel {
  images: ImageModel[];
  attributes: AttributeModel;
  product_discount: ProductDiscount;
  last_product_discounts: ProductDiscount[];
  auction: {
    origin_price: number;
    origin_token: number;
    sell_price: number;
    sell_token: number;
    status: string;
  };
}

/**
 * Query
 */

export type ConversationPayload = {
  comment: string;
};

export type FetchConversationMessagesPayload = {
  limit: number;
  offset: number;
};

export type ConversationMessagesQueryResponse = {
  data: Message[];
};

export type ConversationsQueryPayload = {
  type?: string;
  types?: string[];
  ids?: number[];
  limit?: number;
  offset?: number;
};

export type ConversationsSearchQueryPayload = {
  keyword: string;
};

export type ConversationsQueryResponse = {
  data: Conversation[];
};

export type ConversationQueryResponse = {
  data: Conversation;
};
export type staffUserQueryResponse = {
  data: UserModel;
};
export type User = UserModel;
export type ProductQueryResponse = { data: Product };
export type ImageUploadResponse = {
  data: {
    location: string;
  };
};
/**
 * Const
 */

export type ConversationTypes = Conversation;

export type ProductTypes = Product;

export enum ChatReducerType {
  OnChatSubmit = 'OnChatSubmit',
  OnMessageMapperInit = 'OnMessageMapperInit',
  SetConversationUsers = 'SetConversationUsers',
  SetShowUpdateAliasName = 'SetShowUpdateAliasName',
  SetReplyMessage = 'SetReplyMessage',
}

export type ImageUploadType = {
  data: {
    location: string;
  };
};

export type ReplyMessageState = {
  message: any;
  ownerName: string;
};

export type ChatReducerTypes = {
  messageMapper: { [key: number]: Message };
  groupUsers: UserConversationGroup[];
  isShowUpdateAliasName: boolean;
  replyMessage: ReplyMessageState | null;
};

/**
 * Default !value
 */

export const ConversationPayloadDefault = {
  comment: '',
};

export interface DirectConverSationResponse {
  conversation: Conversation;
  is_new: boolean;
}

export enum UserConversationStatus {
  Unknown = '',
  Pending = 'pending',
  Joined = 'joined',
  Removed = 'removed',
  Leaved = 'leaved',
}

export enum UserConversationRole {
  User = 'user',
  Admin = 'admin',
  Partner = 'partner',
}

export interface UserConversationGroup extends UserConversation {
  id: number;
  conversation_type: ConversationType;
  conversation_id: number;
  status: UserConversationStatus;
  invited_by: number;
  muted_notification: boolean;
  alias_name: string;
}

export interface GetConversationUsersPayload {
  limit: number;
  offset: number;
  user_ids?: number[];
}
export interface GetConversationUsersResponse {
  data: {
    user_conversations: UserConversationGroup[];
  };
}
